import { AxiosResponse } from 'axios';
import {
  SET_YURTZEITEN_EMAIL_TEMPLATE,
  SET_YURTZEITEN_EMAIL_TEMPLATES,
  SET_ERRORMSG,
} from '@/store/mutation_types';
import {
  CHANGE_YURTZEITEN_EMAIL_TEMPLATE_CATEGORY,
  CLEAR_YURTZEITEN_EMAIL_TEMPLATE_ISLOADING,
  DELETE_YURTZEITEN_EMAIL_TEMPLATE,
  EDIT_YURTZEITEN_EMAIL_TEMPLATE,
  GET_YURTZEITEN_EMAIL_TEMPLATE,
  GET_YURTZEITEN_EMAIL_TEMPLATES,
  REGISTER_YURTZEITEN_EMAIL_TEMPLATE,
  TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_ACTIVE,
  TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_DEFAULT,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import YurtzeitenEmailTemplate from '@/services/yurtzeiten_email_template';
import { Module } from 'vuex';
import {
  ChangeYurtzeitenEmailTemplateCategory,
  EditYurtzeitenEmailTemplate,
  GetYurtzeitenEmailTemplate,
  RegisterYurtzeitenEmailTemplate,
  ToggleYurtzeitenEmailTemplateIsActive,
  ToggleYurtzeitenEmailTemplateIsDefault,
} from '@/dtos/yurtzeiten_email_template.dto';

const yurtzeitenEmailTemplate: Module<any, {}> = {
  state: {
    yurtzeitenEmailTemplate: {
      data: null,
      isLoading: false,
    },
    yurtzeitenEmailTemplates: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    yurtzeitenEmailTemplate: (state: { yurtzeitenEmailTemplate: any }) =>
      state.yurtzeitenEmailTemplate,
    yurtzeitenEmailTemplates: (state: { yurtzeitenEmailTemplates: any }) =>
      state.yurtzeitenEmailTemplates,
  },
  mutations: {
    [SET_YURTZEITEN_EMAIL_TEMPLATE]: (
      state: { yurtzeitenEmailTemplate: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.yurtzeitenEmailTemplate.data = payload.data) : null;
      state.yurtzeitenEmailTemplate.isLoading = payload.isLoading;
    },
    [SET_YURTZEITEN_EMAIL_TEMPLATES]: (
      state: { yurtzeitenEmailTemplates: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.yurtzeitenEmailTemplates.data = payload.data) : null;
      state.yurtzeitenEmailTemplates.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_YURTZEITEN_EMAIL_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse =
        await YurtzeitenEmailTemplate.registerYurtzeitenEmailTemplate(
          payload as RegisterYurtzeitenEmailTemplate
        );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_EMAIL_TEMPLATE, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [GET_YURTZEITEN_EMAIL_TEMPLATES]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_EMAIL_TEMPLATES, { data: null, isLoading: true });

      const result: AxiosResponse =
        await YurtzeitenEmailTemplate.getYurtzeitenEmailTemplates(
          payload as GetYurtzeitenEmailTemplate
        );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_EMAIL_TEMPLATES, {
            data: result.data.data,
            isLoading: false,
          });
          return result.data.data;
        }
        commit(SET_YURTZEITEN_EMAIL_TEMPLATES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_EMAIL_TEMPLATES, { isLoading: false });
        return false;
      }
    },
    [GET_YURTZEITEN_EMAIL_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse =
        await YurtzeitenEmailTemplate.getYurtzeitenEmailTemplates(
          payload as GetYurtzeitenEmailTemplate
        );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_EMAIL_TEMPLATE, {
            data: result.data.data?.[0] ?? null,
            isLoading: false,
          });
          return result.data.data?.[0];
        }
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [EDIT_YURTZEITEN_EMAIL_TEMPLATE]: async ({ commit, state }: any, payload: any) => {
      commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse =
        await YurtzeitenEmailTemplate.editYurtzeitenEmailTemplate(
          payload as EditYurtzeitenEmailTemplate
        );

      if (result) {
        if (result.data.status) {
          // Keep the loaded list in step with the saved record so the rail
          // reflects a rename without waiting on a refetch.
          if (Array.isArray(state.yurtzeitenEmailTemplates?.data)) {
            const index = state.yurtzeitenEmailTemplates.data.findIndex(
              (e: any) => e.id == result.data.data.id
            );
            if (index !== -1) {
              state.yurtzeitenEmailTemplates.data[index] = {
                ...state.yurtzeitenEmailTemplates.data[index],
                ...result.data.data,
              };
            }
          }
          commit(SET_YURTZEITEN_EMAIL_TEMPLATE, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_ACTIVE]: async (
      { commit, state }: any,
      payload: ToggleYurtzeitenEmailTemplateIsActive
    ) => {
      commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse =
        await YurtzeitenEmailTemplate.toggleYurtzeitenEmailTemplateIsActive(payload);

      if (result) {
        if (result.data.status) {
          let index: number | null = null;
          if (Array.isArray(state.yurtzeitenEmailTemplates?.data)) {
            state.yurtzeitenEmailTemplates.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null) {
              state.yurtzeitenEmailTemplates.data[index].isActive = result.data.data.isActive;
              // Disabling the default clears it on the server as well.
              state.yurtzeitenEmailTemplates.data[index].isDefault = result.data.data.isDefault;
            }
          }
          commit(SET_YURTZEITEN_EMAIL_TEMPLATE, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_DEFAULT]: async (
      { commit, state }: any,
      payload: ToggleYurtzeitenEmailTemplateIsDefault
    ) => {
      commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse =
        await YurtzeitenEmailTemplate.toggleYurtzeitenEmailTemplateIsDefault(payload);

      if (result) {
        if (result.data.status) {
          const updated = result.data.data;
          // One default per organization and category: when this record became
          // it, the same request cleared whichever record of the same category
          // held it before, so the list follows. The other category's default is
          // untouched. A record with no category predates the split and is a
          // relative's.
          const categoryOf = (e: any) => (e?.category === 'reminder' ? 'reminder' : 'relative');
          if (Array.isArray(state.yurtzeitenEmailTemplates?.data)) {
            state.yurtzeitenEmailTemplates.data.forEach((e: any) => {
              if (e.id == updated.id) {
                e.isDefault = updated.isDefault;
              } else if (updated.isDefault && categoryOf(e) === categoryOf(updated)) {
                e.isDefault = false;
              }
            });
          }
          commit(SET_YURTZEITEN_EMAIL_TEMPLATE, {
            data: updated,
            isLoading: false,
          });
          return true;
        }
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [CHANGE_YURTZEITEN_EMAIL_TEMPLATE_CATEGORY]: async (
      { commit, state }: any,
      payload: ChangeYurtzeitenEmailTemplateCategory
    ) => {
      commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse =
        await YurtzeitenEmailTemplate.changeYurtzeitenEmailTemplateCategory(payload);

      if (result) {
        if (result.data.status) {
          const updated = result.data.data;
          // Patched in place, so the record moves between the Studio's lists
          // without a refetch — its default flag with it, which the move clears.
          if (Array.isArray(state.yurtzeitenEmailTemplates?.data)) {
            const listed = state.yurtzeitenEmailTemplates.data.find((e: any) => e.id == updated.id);
            if (listed) {
              listed.category = updated.category;
              listed.isDefault = updated.isDefault;
            }
          }
          commit(SET_YURTZEITEN_EMAIL_TEMPLATE, {
            data: updated,
            isLoading: false,
          });
          return true;
        }
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [DELETE_YURTZEITEN_EMAIL_TEMPLATE]: async ({ commit }: any, payload: string) => {
      commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse =
        await YurtzeitenEmailTemplate.deleteYurtzeitenEmailTemplate(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_EMAIL_TEMPLATE, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_YURTZEITEN_EMAIL_TEMPLATE_ISLOADING]: ({ commit }) => {
      commit(SET_YURTZEITEN_EMAIL_TEMPLATE, { isLoading: false });
      commit(SET_YURTZEITEN_EMAIL_TEMPLATES, { isLoading: false });
    },
  },
};

export default yurtzeitenEmailTemplate;
